import { render, staticRenderFns } from "./admin-dashboard.vue?vue&type=template&id=a6f7544e&scoped=true&"
import script from "./admin-dashboard.vue?vue&type=script&lang=js&"
export * from "./admin-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./admin-dashboard.vue?vue&type=style&index=0&id=a6f7544e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f7544e",
  null
  
)

export default component.exports